import { createSlice } from '@reduxjs/toolkit';
import { addExtraReducer } from '../../utils/addExtraReducer';
import initialState from './initialState';
import {
  ClearSelectedFactoryOptionsUserReducer,
  CreateFactoryOptionsReducer,
  DeleteFactoryOptionReducer,
  GetFactoryOptionByIdReducer,
  GetFactoryOptionsReducer,
  ImportFactoryOptionsReducer,
  ResetFactoryOptionsStateReducers,
  UpdateFactoryOptionReducer,
  UpdateInactiveReducer,
} from './reducers';
import {
  CreateFactoryOption,
  DeleteFactoryOption,
  GetFactoryOptionById,
  GetFactoryOptions,
  ImportFactoryOptions,
  UpdateFactoryOption,
  UpdateInactive,
} from './thunks';

// ----------------------------------------------------------------------------

// slice
export const slice = createSlice({
  name: 'factoryOptions',
  initialState,
  reducers: {
    ClearSelectedFactoryOptionUser: ClearSelectedFactoryOptionsUserReducer,
    ResetFactoryOptionsState: ResetFactoryOptionsStateReducers,
  },
  extraReducers: (builder) => {
    addExtraReducer(builder, GetFactoryOptions, GetFactoryOptionsReducer);
    addExtraReducer(builder, ImportFactoryOptions, ImportFactoryOptionsReducer);
    addExtraReducer(builder, GetFactoryOptionById, GetFactoryOptionByIdReducer);
    addExtraReducer(builder, UpdateFactoryOption, UpdateFactoryOptionReducer);
    addExtraReducer(builder, UpdateInactive, UpdateInactiveReducer);
    addExtraReducer(builder, DeleteFactoryOption, DeleteFactoryOptionReducer);
    addExtraReducer(builder, CreateFactoryOption, CreateFactoryOptionsReducer);
  },
});

export default slice.reducer;
